<div class="login ver2" [ngClass]="{'fly-out': isFlyout}">
	<!-- Site header - reduced to just register button on login page -->
	<header class="site-nav" *ngIf="!isFlyout">
		<div class="row">
			<a (click)="gotoRegister();" class="btn tertiary">Register</a>
		</div>
	</header>
	<main>
		<div class="row">
			<div class="col">
				<a href="/" *ngIf="!isFlyout">
					<img src="{{configurationService.assetsPath}}/assets/img/logos/rankipedia-logo.png" alt="Rankipedia">
				</a>
				<h1>Sign In</h1>
				<span>Don’t have an account? <a (click)="gotoRegister();">Register here</a></span>
				<form #frmlogin="ngForm" (submit)="onSubmit()">
					<div class="field form-group">
						<input type="email" id="login-email" placeholder="Email Address/Phone" name="username"
							   [(ngModel)]="userLogin.userName" #username="ngModel" [ngModelOptions]="{standalone: true}" required
							   ngClass="form-control inputvalid">
						<label for="login-email">Email Address/Phone</label>
					</div>
					<div class="field form-group">
						<input type="password" id="login-pwd" placeholder="Password" [(ngModel)]="userLogin.password" required
							   [ngModelOptions]="{standalone: true}">
						<label for="login-pwd">Password</label>
					</div>
					<div class="row">
						<div>
							<input type="checkbox" id="login-remember" [(ngModel)]="userLogin.rememberMe" name="rememberMe" [ngModelOptions]="{standalone: true}">
							<label for="login-remember">Remember Me</label>
						</div>
						<a (click)="recoverPassword()" *ngIf="!isFlyout">Forgot your password?</a>
					</div>
					<button class="btn primary" type="submit" disabled>Sign In</button>
				</form>
				<a onclick="parent.callbackParent();" style="display:none;" id="btnCallback" href="javascript:void(0);">cbk</a>
<!--				<span class="separator">Or</span>
				<a (click)="signInWithFB()" class="social-btn fb">Sign In with Facebook</a>
				<a (click)="signInWithGoogle()" class="social-btn google">Sign In with Google</a>-->
			</div>
			<div class="col promo">
				<div class="promotion shield">
					<h2>
						Introducing <strong>The Rankipedia Plaque</strong>
						<span>For Professionals</span>
					</h2>
					<p>
						The proof-at-a-glance tool consumers demand that shows your commitment to quality and excellence!
					</p>
					<p>
						<strong>Free with all professional memberships!</strong>
					</p>
					<img id="rankipedia-plaque" src="/professional/GetRandomSponsor?force={{inLogin}}" title="Rankipedia Plaque" alt="Rankipedia Plaque" />
				</div>
			</div>
		</div>
	</main>
	<!-- Site footer -->
	<footer class="site-footer" *ngIf="!isFlyout">
		<div class="row">
			<div class="links">
				<ul>
					<li>
						<a href="{{configurationService.homeUrl}}TermsOfUse" target="_blank">Terms of Use</a>
					</li>
					<li>
						<a href="{{configurationService.homeUrl}}PrivacyPolicy" target="_blank">Privacy Policy</a>
					</li>
				</ul>
				<small>Copyright © <span id="copyright-year"></span> RankLogic, Inc. All rights reserved.</small>
			</div>
		</div>
	</footer>
</div>
<script>
	$(document).ready(function () {
		var year = new Date().getFullYear();
		$("#copyright-year")[0].innerText = year;
	});
</script>
